import { Link } from 'react-router-dom';
import { FiArrowUpRight, FiDownload, FiMessageCircle, FiPlay } from 'react-icons/fi';
import { Template } from '../Template';
import { releases } from './releases';
import './Download.css';

export const Download = () => <Template>
  <section className="main-container download-page">
    <span className="eyebrow"><span className="status-dot" /> SLICK / DOWNLOAD</span>
    <h1>Your next print<br />starts here.</h1>
    <p className="page-description">Get Slick Slicer and bring your resin printing workflow to life. Find available builds and download information here.</p>

    <div className="download-content">
      <section className="download-panel" aria-labelledby="download-title">
        <div className="download-icon"><FiDownload aria-hidden="true" /></div>
        <div className="download-panel-copy">
          <span className="eyebrow">{releases.length ? 'AVAILABLE BUILDS' : 'IN DEVELOPMENT'}</span>
          <h2 id="download-title">{releases.length ? 'Download Slick Slicer' : 'Slick is taking shape.'}</h2>
          {releases.length ? <>
            <p>Choose the build for your system.</p>
            <ul className="download-builds">
              {releases.map(release => <li key={release.url}>
                <div><h3>{release.platform}</h3><span>Version {release.version} · {release.fileLabel}</span></div>
                <a className="button button-primary" href={release.url}>Download for {release.platform} <FiDownload aria-hidden="true" /></a>
              </li>)}
            </ul>
          </> : <>
            <p>We're working on a fast, lightweight slicer for resin printing. A free demo is planned; installers aren't available on this page yet.</p>
            <div className="download-status"><span className="status-dot" /> Download links coming soon</div>
            <p className="download-detail">Supported systems, requirements, and installation details will be listed alongside each build when it's ready.</p>
            <div className="download-actions">
              <a className="button button-primary" href="https://discord.gg/TPrDj9rYm" target="_blank" rel="noopener noreferrer">Follow on Discord <FiArrowUpRight aria-hidden="true" /></a>
              <a className="button button-secondary" href="https://www.patreon.com/cw/SlickSlicer/membership" target="_blank" rel="noopener noreferrer">Support on Patreon <FiArrowUpRight aria-hidden="true" /></a>
            </div>
          </>}
        </div>
      </section>

      <div className="download-help-grid">
        <article className="download-help">
          <FiPlay aria-hidden="true" /><h2>See it in action.</h2>
          <p>Take a look at model preparation and layer-by-layer slicing in our development demos.</p>
          <Link to="/">Explore the demos <FiArrowUpRight aria-hidden="true" /></Link>
        </article>
        <article className="download-help">
          <FiMessageCircle aria-hidden="true" /><h2>Let's talk slicing.</h2>
          <p>Have a question about availability or a feature you'd love to use? Get in touch with our small team.</p>
          <Link to="/contact">Contact the team <FiArrowUpRight aria-hidden="true" /></Link>
        </article>
      </div>
    </div>
  </section>
</Template>;
